var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.format,style:(_vm.iteration == 0 ? { 'text-align': 'left' } : { 'text-align': 'right' })},[_vm._v("\n  "+_vm._s(isNaN(_vm.value) ? _vm.clearCase(_vm.value) : _vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }